import "core-js/modules/es.function.name.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-60b3e47d"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = {
  class: "start"
};
var _hoisted_3 = {
  class: "content"
};
var _hoisted_4 = {
  class: "type"
};
var _hoisted_5 = {
  key: 0
};
var _hoisted_6 = {
  key: 1
};

var _hoisted_7 = /*#__PURE__*/_createTextVNode(" 上一题 ");

var _hoisted_8 = /*#__PURE__*/_createTextVNode(" 下一题 ");

var _hoisted_9 = {
  key: 0,
  class: "btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_col = _resolveComponent("el-col");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_radio = _resolveComponent("el-radio");

  var _component_el_radio_group = _resolveComponent("el-radio-group");

  var _component_el_checkbox = _resolveComponent("el-checkbox");

  var _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

  var _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Data.detail, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.question, function (item1, index1) {
      return _openBlock(), _createElementBlock("div", {
        key: index1
      }, [_ctx.Data.num == index1 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_row, {
        class: "title"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("span", null, " 第 " + _toDisplayString(index1 + 1) + " 题 ", 1)];
            }),
            _: 2
          }, 1024)];
        }),
        _: 2
      }, 1024)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, "[" + _toDisplayString(item1.answerType == 1 ? "单选" : "多选") + "]", 1), _createElementVNode("span", null, _toDisplayString(item1.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item1.options, function (item2, index2) {
        return _openBlock(), _createElementBlock("div", {
          key: index2
        }, [item1.answerType == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_radio_group, {
          modelValue: _ctx.Data.answer[index1].answer,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return _ctx.Data.answer[index1].answer = $event;
          }
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_el_radio, {
              label: String(index2 + 1),
              disabled: _ctx.Data.flag == false
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item2.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "disabled"])];
          }),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue"])])) : _createCommentVNode("", true), item1.answerType == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_checkbox_group, {
          modelValue: _ctx.Data.answer[index1].answer,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return _ctx.Data.answer[index1].answer = $event;
          }
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_el_checkbox, {
              label: String(index2 + 1),
              disabled: _ctx.Data.flag == false
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item2.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "disabled"])];
          }),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue"])])) : _createCommentVNode("", true)]);
      }), 128))])])) : _createCommentVNode("", true)]);
    }), 128))]);
  }), 128)), _createElementVNode("div", null, [_createVNode(_component_el_row, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 3
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            class: "anniu",
            disabled: _ctx.Data.preDisabled,
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return _ctx.pre();
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_7];
            }),
            _: 1
          }, 8, ["disabled"])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 6
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            class: "anniu",
            disabled: _ctx.Data.nextDisabled,
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return _ctx.next();
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_8];
            }),
            _: 1
          }, 8, ["disabled"])];
        }),
        _: 1
      })];
    }),
    _: 1
  })]), _ctx.Data.flag == true ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", {
    class: "submit",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.submit();
    })
  }, " 提交 ")])) : _createCommentVNode("", true)], 64);
}